import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowUp } from '@fortawesome/free-solid-svg-icons';


const Scroll = () => {
  const [showScroll, setShowScroll] = useState(false);

  // Add scroll event listener using useEffect
  useEffect(() => {
    const handleScroll = () => {
      if (window.pageYOffset > 200) {
        // Show scroll-to-top button when scrolled down 200px
        setShowScroll(true);
      } else {
        // Hide scroll-to-top button when not scrolled down enough
        setShowScroll(false);
      }
    };

    window.addEventListener('scroll', handleScroll);

    // Clean up the event listener on component unmount
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []); // Empty dependency array ensures effect runs only once on mount

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <div className={`scroll-to-top ${showScroll ? 'scroll-true' : 'scroll-false'}`}>
      <a href="#" onClick={scrollToTop}>
        <FontAwesomeIcon icon={faArrowUp} className="fa-solid fa-arrow-up" />
      </a>
    </div>
  );
};

export default Scroll;
